
<content class='image'>
  <div class="cross">
    <button type="button" class="close" aria-label="Close" (click)="_activeModal.dismiss('Cross click')">
      <span >x</span>
    </button>
  </div>
<img (mouseup)="_activeModal.dismiss('Cross click')" [src]="_galleryService.bigImageViewSrc">
</content>
